import React from 'react';
import ServiceTemplate from './ServiceTemplate';
import { Trash2 } from 'lucide-react';

const SperrmuellDortmund = () => {
  return (
    <ServiceTemplate
      title="Sperrmüll-Abtransport in Dortmund"
      slug="sperrmuell-abtransport-dortmund"
      icon={Trash2}
      intro="Kurzfristiger Abtransport von Sperrmüll, Möbeln und Altgeräten in Dortmund. Keine langen Wartezeiten auf die städtische Abholung. Wir kommen schnell, laden alles auf und entsorgen fachgerecht. Fairer Festpreis, auch für große Mengen."
      whatIncluded="Abholung und Abtransport von Möbeln, Matratzen, Teppichen, Elektrogeräten, Fahrrädern und sonstigem Sperrmüll. Demontage bei Bedarf. Verladen, Transport und gesetzeskonforme Entsorgung inklusive."
      whenNeeded="Perfekt bei Renovierung, nach Wohnungsauflösung, bei spontanem Bedarf oder wenn die städtische Sperrmüllabholung zu lange dauert. Auch bei großen Mengen oder sperrigen Gegenständen."
      pricing="Abhängig von Menge und Art: Einzelstücke ab 50 €, Transporter-Ladung 200–500 €, LKW-Ladung 500–1.200 €. Nach Foto-Zusendung oder kurzer Beschreibung erhalten Sie sofort ein Angebot. Abholung oft am selben oder nächsten Tag."
      valueCredit="Funktionsfähige Geräte oder verwertbare Möbel werden angerechnet. So sparen Sie bei der Entsorgung."
      disposal="Wir entsorgen über zertifizierte Entsorgungspartner: Elektroschrott wird recycelt, Altholz stofflich verwertet, Restmüll ordnungsgemäß beseitigt. Entsorgungsnachweise auf Wunsch."
    />
  );
};

export default SperrmuellDortmund;